import Img from '@admin/components/html/img'
import PropTypes from 'prop-types'
import moment from 'moment'
import React from 'react'

const PayoutToken = ({ payout }) => (
  <div className="source-token">
    <div className="source-token-icon">
      <Img src={`/images/services/${payout.service}.png`} />
    </div>
    <div className="source-token-text">
      { moment(payout.date).format('MMMM YYYY') }
    </div>
  </div>
)

PayoutToken.propTypes = {
  payout: PropTypes.object
}

export default PayoutToken
